import intl from 'react-intl-universal'

export default [
  {
    text: intl.get('picklist.sort.nameAscText'),
    id: 'name_ascending',
    sort: (a, b) => {
      const x = a.text.toLowerCase()
      const y = b.text.toLowerCase()
      if (x < y) {
        return -1
      } else if (x > y) {
        return 1
      } else {
        return 0
      }
    },
  },
  {
    text: intl.get('picklist.sort.nameDescText'),
    id: 'name_descending',
    sort: (a, b) => {
      const x = a.text.toLowerCase()
      const y = b.text.toLowerCase()
      if (x < y) {
        return 1
      } else if (x > y) {
        return -1
      } else {
        return 0
      }
    },
  },
  {
    text: intl.get('picklist.sort.idAscText'),
    id: 'id_ascending',
    sort: (a, b) => {
      const x = a.id.toLowerCase()
      const y = b.id.toLowerCase()
      if (x < y) {
        return -1
      } else if (x > y) {
        return 1
      } else {
        return 0
      }
    },
  },
  {
    text: intl.get('picklist.sort.idDescText'),
    id: 'id_descending',
    sort: (a, b) => {
      const x = a.id.toLowerCase()
      const y = b.id.toLowerCase()
      if (x < y) {
        return 1
      } else if (x > y) {
        return -1
      } else {
        return 0
      }
    },
  },
  {
    text: intl.get('picklist.sort.custom'),
    id: 'custom',
    sort: (a, b) => {
      const x = a.order
      const y = b.order
      if (x < y) {
        return 1
      } else if (x > y) {
        return -1
      } else {
        return 0
      }
    },
  },
]
